import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { SpecialOfferListComponent } from './special-offer-list/special-offer-list.component';

import { PreviewComponent } from './special-offer-list/preview/preview.component';
import { SpecialOfferRequestedComponent } from './special-offer-list/preview/special-offer-requested/special-offer-requested.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { SPECIAL_OFFER_ROUTES } from 'src/app/core/constants/routes-constants';

const routes: Routes = [
  {
    path: SPECIAL_OFFER_ROUTES.SPECIAL_OFFERS,
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: SpecialOfferListComponent },
      {
        path: SPECIAL_OFFER_ROUTES.SPECIAL_OFFER_REQUESTED,
        component: SpecialOfferRequestedComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.PREVIEW}/:specialOfferId`,
        component: PreviewComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class SpecialOfferRoutingModule {}
